import {Link, withRouter} from 'react-router-dom'
import Cookies from 'js-cookie'
import './index.css'

const Header = props => {
  const logout = () => {
    const {history} = props
    Cookies.remove('jwt_token')
    history.replace('/login')
  }

  return (
    <ul className="head-cont">
      <li className="head-opt1">
        <Link to="/">
          <img
            className="head-logo"
            src="https://assets.ccbp.in/frontend/react-js/logo-img.png"
            alt="website logo"
          />
        </Link>
      </li>
      <li className="head-opt2">
        <Link to="/">
          <li>
            <p className="head-home">Home</p>
          </li>
        </Link>
        <Link to="/jobs">
          <li>
            <p className="head-jobs">Jobs</p>
          </li>
        </Link>
      </li>
      <li className="head-opt3">
        <button onClick={logout} type="button" className="headbtn">
          Logout
        </button>
      </li>
    </ul>
  )
}
export default withRouter(Header)
